import { IconProps } from "../../models/Icon";

export function CalendarIcon({ size = 20, color = "#000", opacity = "1" }: IconProps) {

  return (
    <svg 
        width={size} 
        height={size} 
        viewBox="0 0 14 14" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
    >
        <path 
            d="M1.09375 12.0308C1.09375 12.2728 1.28926 12.4683 1.53125 12.4683H11.5938C11.8357 12.4683 12.0312 12.2728 12.0312 12.0308V6.28857H1.09375V12.0308ZM11.5938 2.51514H9.29688V1.64014C9.29688 1.57998 9.24766 1.53076 9.1875 1.53076H8.42188C8.36172 1.53076 8.3125 1.57998 8.3125 1.64014V2.51514H4.8125V1.64014C4.8125 1.57998 4.76328 1.53076 4.70312 1.53076H3.9375C3.87734 1.53076 3.82812 1.57998 3.82812 1.64014V2.51514H1.53125C1.28926 2.51514 1.09375 2.71064 1.09375 2.95264V5.35889H12.0312V2.95264C12.0312 2.71064 11.8357 2.51514 11.5938 2.51514Z" 
            fill={color}
            fillOpacity={opacity}
        />
    </svg>

  )
}